import { memo } from "react";
import {
  Container,
  SimpleGrid,
  Image,
  Flex,
  Text as ChakraText,
  Stack,
  StackDivider,
  useColorModeValue,
  Button,
} from "@chakra-ui/react";
import HeadingTitle from "./HeadingTitle";
import Text from "./shared/typography/Text";

const SplitFeatureImage = memo(({ source }) => {
  return (
    <Flex>
      <Image
        rounded={"md"}
        alt={"feature image"}
        src={source}
        objectFit={"cover"}
        loading="eager"
      />
    </Flex>
  );
});

SplitFeatureImage.displayName = 'SplitFeatureImage';

const SplitFeatureText = memo(({ btnId, tag, headerTitle, content }) => {
  return (
    <Stack spacing={4}>
      <ChakraText
        textTransform={"uppercase"}
        color={"gray.600"}
        fontWeight={600}
        fontSize={"sm"}
        bg={useColorModeValue("gray.50", "gray.900")}
        p={2}
        alignSelf={"flex-start"}
        rounded={"md"}
      >
        {tag}
      </ChakraText>
      <HeadingTitle mainTitle={headerTitle} align={"left"} />
      <Stack
        spacing={4}
        divider={
          <StackDivider
            borderColor={useColorModeValue("gray.100", "gray.700")}
          />
        }
      >
        <Text content={content} />
      </Stack>
      <Stack
        spacing={{ base: 4, sm: 6 }}
        direction={{ base: "column", sm: "row" }}
      >
        <Button
          as="a"
          id={btnId}
          href="/sign-up"
          rounded={"full"}
          px={6}
          colorScheme={"black"}
          bg={"black"}
          _hover={{ bg: "gray.400", color: "black" }}
        >
          SIGN UP NOW
        </Button>
      </Stack>
    </Stack>
  );
});

SplitFeatureText.displayName = 'SplitFeatureText';

function SplitFeature({
  btnId,
  tag,
  headerTitle,
  content,
  paddingBottom = 10,
  featureImage
}) {
  return (
    <Container maxW={"5xl"} pt={10} pb={paddingBottom}>
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
        <SplitFeatureImage source={featureImage} />
        <SplitFeatureText
          btnId={btnId}
          tag={tag}
          headerTitle={headerTitle}
          content={content}
        />
      </SimpleGrid>
    </Container>
  );
}

export default memo(SplitFeature)